/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: aeeb275c (Fri Jul 31 21:53:12 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  CoordinatorLicensingBilling,
  CoordinatorLicensingBillingFromJSON,
  CoordinatorLicensingBillingToJSON,
  PaginationResponse,
  PaginationResponseFromJSON,
  PaginationResponseToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchBillingResponseLicensingDirectorBilling
 */
export interface FetchBillingResponseLicensingDirectorBilling {
  /**
   * An array of licensing billing records for coordinator directors.
   * @type {Array<CoordinatorLicensingBilling>}
   * @memberof FetchBillingResponseLicensingDirectorBilling
   */
  data?: Array<CoordinatorLicensingBilling>
  /**
   *
   * @type PaginationResponse
   * @memberof FetchBillingResponseLicensingDirectorBilling
   */
  pagination?: PaginationResponse
}

export function FetchBillingResponseLicensingDirectorBillingFromJSON(
  json: any
): FetchBillingResponseLicensingDirectorBilling {
  return FetchBillingResponseLicensingDirectorBillingFromJSONTyped(json, false)
}

export function FetchBillingResponseLicensingDirectorBillingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchBillingResponseLicensingDirectorBilling {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: !exists(json, 'data')
      ? undefined
      : (json['data'] as Array<any>).map(CoordinatorLicensingBillingFromJSON),
    pagination: !exists(json, 'pagination')
      ? undefined
      : PaginationResponseFromJSON(json['pagination']),
  }
}

export function FetchBillingResponseLicensingDirectorBillingToJSON(
  value?: FetchBillingResponseLicensingDirectorBilling | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : (value.data as Array<any>).map(CoordinatorLicensingBillingToJSON),
    pagination: PaginationResponseToJSON(value.pagination),
  }
}
